import React from "react";
import Facts from "components/Facts";

import { addRoundedRect, borderRadius } from "../svgUtils";

const width = 180;
const height = 80;
const containingRadius = Math.sqrt(width * width + height * height) / 2;

const labelWidth = 40;
const maxBarWidth = width - 2 - labelWidth - 2 - 5;

export default {
  layout: { radius: containingRadius },
  render: {
    enter: (item) => {
      const { elem: e, label } = item;

      addRoundedRect(
        e,
        -width / 2,
        -height / 2,
        width,
        height,
        borderRadius,
        0.5
      )
        .attr("fill", "white")
        .attr("stroke", "black");

      item.titleElem = e
        .append("text")
        .attr("x", -width / 2 + 2)
        .attr("y", -height / 2 + 12 + 2);

      item.bottomText = e
        .append("text")
        .attr("x", -width / 2 + 2)
        .attr("y", height / 2 - 2);

      item.statusDot = e
        .append("circle")
        .attr("cx", width / 2 - 2 - 7)
        .attr("cy", height / 2 - 2 - 7)
        .attr("r", 7)
        .attr("stroke", "#d0d0d0")
        .attr("fill", "grey");

      // label for CPU
      e.append("text")
        .attr("x", -width / 2 + 2)
        .attr("y", 6 - 12 - 2)
        .text("CPU");

      // label for RAM
      e.append("text")
        .attr("x", -width / 2 + 2)
        .attr("y", 6)
        .text("RAM");

      // label for Disk
      e.append("text")
        .attr("x", -width / 2 + 2)
        .attr("y", 6 + 12 + 2)
        .text("Disk");

      // background bar for CPU
      e.append("rect")
        .attr("x", -width / 2 + 2 + labelWidth)
        .attr("y", 1 - 12 - 2 - 5)
        .attr("width", maxBarWidth)
        .attr("height", 10)
        .attr("fill", "#d0d0d0");
      item.cpuBar = e
        .append("rect")
        .attr("x", -width / 2 + 2 + labelWidth)
        .attr("y", 1 - 12 - 2 - 5)
        .attr("width", 0)
        .attr("height", 10)
        .attr("fill", "green");

      // background bar for RAM
      e.append("rect")
        .attr("x", -width / 2 + 2 + labelWidth)
        .attr("y", 1 - 5)
        .attr("width", maxBarWidth)
        .attr("height", 10)
        .attr("fill", "#d0d0d0");
      item.ramBar = e
        .append("rect")
        .attr("x", -width / 2 + 2 + labelWidth)
        .attr("y", 1 - 5)
        .attr("width", 0)
        .attr("height", 10)
        .attr("fill", "green");

      // background bar for Disk
      e.append("rect")
        .attr("x", -width / 2 + 2 + labelWidth)
        .attr("y", 1 + 12 + 2 - 5)
        .attr("width", maxBarWidth)
        .attr("height", 10)
        .attr("fill", "#d0d0d0");
      item.diskBar = e
        .append("rect")
        .attr("x", -width / 2 + 2 + labelWidth)
        .attr("y", 1 + 12 + 2 - 5)
        .attr("width", 0)
        .attr("height", 10)
        .attr("fill", "green");

      (item.updateTitle = () =>
        item.titleElem.text(
          item.data
            ? JSON.parse(item.data)
                .uri.replaceAll("http://", "")
                .replaceAll("https://", "")
            : item.label
        ))();
    },
    update: (item) => {
      item.updateTitle();
    },
  },
  eventHandlers: {
    status: (item, data, ui) => {
      const dataObj = JSON.parse(data);
      item.bottomText.text(
        `${dataObj.nodes} nodes, ${dataObj.documents.toLocaleString()} docs`
      );
      item.statusDot.attr("fill", dataObj.status.toLowerCase());

      const doBar = (i, f) => {
        i.attr("width", f * maxBarWidth).attr(
          "fill",
          f < 0.5 ? "green" : f < 0.8 ? "orange" : "red"
        );
      };

      doBar(item.cpuBar, dataObj.cpu_percent / 100.0);
      doBar(item.ramBar, dataObj.mem_used / dataObj.mem_max);
      doBar(item.diskBar, 1 - dataObj.fs_available / dataObj.fs_total);
    },
  },
  renderInfoHead: (t) => t.data || "(No full name)",
  renderInfoBody: (t) => (
    <Facts>
      <Facts.Fact label="Data" value={t.data || ""} />
    </Facts>
  ),
};
